import { ConcatePath } from "./utils";

export class AppSettings {
  //static readonly API_ENDPOINT = 'http://localhost/BCAAcquires.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://localhost/BCAAcquires.AuthorizationServer.API';
  //static readonly API_ENDPOINT = 'http://malikapi.commdel.com/Merchant.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://malikapi.commdel.com/Merchant.AuthorizationServer.API';
  //static readonly API_ENDPOINT = 'http://MalikAPI.commdel.com/PrepaidCredit.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://MalikAPI.commdel.com/PrepaidCredit.AuthorizationServer.API';

  // static readonly API_ENDPOINT = 'http://iglapi.commdel.com/iglAPI/';
  // static readonly API_AUTHORIZATION_ENDPOINT = 'http://iglapi.commdel.com/iglAuthorizationAPI';

  // static readonly API_ENDPOINT = 'http://192.168.27.196:8002/';
  // static readonly API_AUTHORIZATION_ENDPOINT = 'http://192.168.27.196:8003/';

   static readonly API_ENDPOINT = "https://uat-igl-api-v1.prepaidxchange.com/";
  static readonly API_AUTHORIZATION_ENDPOINT =
    "https://uat-igl-auth.prepaidxchange.com/";
  static readonly API_MERCHANT_ENDPOINT =
    "https://uat-igl-mapi.prepaidxchange.com/";
  static readonly API_CUSTOMER_ENDPOINT =
    "https://uat-igl-capi.prepaidxchange.com/";
    
  // static readonly API_ENDPOINT = 'https://iglcustomerportal.commdel.com/webapi/';
  // static readonly API_AUTHORIZATION_ENDPOINT = 'https://iglcustomerportal.commdel.com/webauthapi/';

  // static readonly API_ENDPOINT = 'http://patanjaliapi.commdel.com/PantanjaliPortal.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://patanjaliapi.commdel.com/Patanjali.AuthorizationServer.API';
  // static readonly API_ENDPOINT = 'http://192.168.29.102/CUGPayment.API/';
  // static readonly API_AUTHORIZATION_ENDPOINT = 'http://192.168.29.102/CUGPayment.AuthorizationServer.API';
  //static readonly API_ENDPOINT = 'http://malikapi.commdel.com/CUGPayment.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://malikapi.commdel.com/CUGPayment.AuthorizationServer.API';
  // static readonly API_ENDPOINT = 'http://192.168.29.156/CUGPayment.API/';
  //static readonly API_AUTHORIZATION_ENDPOINT = 'http://192.168.29.156/CUGPayment.AuthorizationServer.API';
  static readonly APP_BASEURL = "http://localhost:4200";
  static readonly LoginPath = "/pre-login"; //pre-login FOR MGL/IGL   //login for others like easypymtz
  static readonly showDynamicHeadLogo: boolean = false;
  static readonly changeDynamicCss: boolean = false;
  static readonly showMerchantDashboardPaymentDetailBoxes = true;
  static readonly showIssueStatusDropdown = false;
}


// WEBPACK FOOTER //
// ./src/app/common/app-setting.ts